import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite/no-important';
import Logo from './Logo';
import StyleUtils from './StyleUtils';

class NavBar extends Component {

  render() {

    return (
      <Fragment>
        <div className={css(styles.mainNavHolder)}>
          <div className={css(styles.mainNavMax)}>
            <Logo windowWidth={this.props.windowWidth} />
            <ul className={css(styles.menuOptionsList)}>
              <li className={css(styles.menuOption)}>
                <Link to="/#positions" className={css(styles.menuOptionsLink)}>
                  {'All Positions'}
                </Link>
              </li>
              <li className={css(styles.menuOption)}>
                <Link to="/#contact" className={css(styles.menuOptionsLink)}>
                  {'Contact'}
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className={css(styles.headerSpacer)} />
      </Fragment>
    );
  }
}

const styles = StyleSheet.create({
  headerSpacer: {
    height: StyleUtils.headerHeight,
    width: '100%',
  },
  mainNavHolder: {
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    boxShadow: StyleUtils.stdBoxShadow,
    display: 'flex',
    height: StyleUtils.headerHeight,
    justifyContent: 'center',
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 5,
    backdropFilter: 'blur(5px)',
  },
  mainNavMax: {
    display: 'block',
    height: 'auto',
    maxWidth: 1024,
    overflow: 'hidden',
    width: '100%',
  },
  menuOption: {
    display: 'inline',
    marginLeft: 15,
  },
  menuOptionsLink: {
    color: StyleUtils.almostBlack,
    fontFamily: StyleUtils.mainFont,
    fontSize: 14,
    fontWeight: 400,
    textDecoration: 'none',
    textTransform: 'uppercase',
    transitions: StyleUtils.fastTransition,
    ':hover': {
      color: StyleUtils.highlightGrey,
    },
  },
  menuOptionsList: {
    display: 'inline',
    float: 'right',
    listStyle: 'none',
    listStylePosition: 'inside',
    margin: '16px 0px 16px 0px',
    padding: 0,
    right: 0,
    '@media only screen and (max-width: 1050px)': {
      margin: '12px 15px 0px 0px',
    },
  },
});

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar.jsx